export const MASSLETTER_SENT_SUCCESSFULLY = "massLetter.MASSLETTER_SENT_SUCCESSFULLY";
export const MASSLETTER_CANCELED_SUCCESSFULLY = "massLetter.MASSLETTER_CANCELED_SUCCESSFULLY";
export const MASSLETTER_RESET_SUCCESSFULLY = "massLetter.MASSLETTER_RESET_SUCCESSFULLY";

export const MASSLETTERS_FETCH_SUCCESSFULLY = "massLetter.MASSLETTERS_FETCH_SUCCESSFULLY";
export const MASSLETTERS_FETCH_FAILED = "massLetter.MASSLETTERS_FETCH_FAILED";
